export const Arr_MedicationsInfo = [
  // Start medication 1
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any other medication",
    name: "MedicationsInfo_other_prescribed_medication_1",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <>
        <h2>Medications</h2>{" "}
        <p>
          Does the student take any prescribed medication not already declared
          on this form
        </p>
      </>
    ),
  },
  // medication 1 main
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what this medication is for",
    name: "MedicationsInfo_other_prescribed_medication_1_for",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Self Administer",
    name: "MedicationsInfo_other_prescribed_medication_1_self_administer",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: <p>Can the student administer their own medication</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Category",
    name: "MedicationsInfo_other_prescribed_medication_1_category",
    selectValues: [
      "Daily prescribed medication (e.g. birth control, Accutane, growth hormones) not already listed on the form",
      "Life-saving medication or equipment not already listed on the form",
      "Other",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: <p>Does the medication fall under any of these categories</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_other_prescribed_medication_1_category_specify",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1_category",
  },
  // Medication 1 Medication start

  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MedicationsInfo_medication_1_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MedicationsInfo_medication_1_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MedicationsInfo_medication_1_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MedicationsInfo_medication_1_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "MedicationsInfo_medication_1_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MedicationsInfo_medication_1_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MedicationsInfo_medication_1_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MedicationsInfo_medication_1_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MedicationsInfo_medication_1_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_1_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_1_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "MedicationsInfo_medication_1_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_1_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_1_prescribed_medication_storage_requirements",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MedicationsInfo_medication_1_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_1_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_1_prescribed_medication_anything_else",
  },

  // Medication 1 Medication end

  // Start medication 2
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any other medication",
    name: "MedicationsInfo_other_prescribed_medication_2",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_1",
    AboveText: (
      <>
        <h2>Medications</h2>{" "}
        <p>
          Does the student take any prescribed medication not already declared
          on this form
        </p>
      </>
    ),
  },
  // medication 2 main
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what this medication is for",
    name: "MedicationsInfo_other_prescribed_medication_2_for",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Self Administer",
    name: "MedicationsInfo_other_prescribed_medication_2_self_administer",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: <p>Can the student administer their own medication</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Category",
    name: "MedicationsInfo_other_prescribed_medication_2_category",
    selectValues: [
      "Daily prescribed medication (e.g. birth control, Accutane, growth hormones) not already listed on the form",
      "Life-saving medication or equipment not already listed on the form",
      "Other",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: <p>Does the medication fall under any of these categories</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_other_prescribed_medication_2_category_specify",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2_category",
  },
  // Medication 2 Medication start

  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MedicationsInfo_medication_2_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },

  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MedicationsInfo_medication_2_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MedicationsInfo_medication_2_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MedicationsInfo_medication_2_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. injection/ tablet)",
    name: "MedicationsInfo_medication_2_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MedicationsInfo_medication_2_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MedicationsInfo_medication_2_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MedicationsInfo_medication_2_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MedicationsInfo_medication_2_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_2_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_2_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "MedicationsInfo_medication_2_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_2_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_2_prescribed_medication_storage_requirements",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MedicationsInfo_medication_2_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MedicationsInfo_other_prescribed_medication_2",
    AboveText: (
      <>
        <p>
          If you take any additional medication, not mentioned above or in
          another page of the form, please email info@investin.org
        </p>
        <p>
          Is there anything else we need to know about this treatment/
          medication
        </p>
      </>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MedicationsInfo_medication_2_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MedicationsInfo_medication_2_prescribed_medication_anything_else",
  },

  // Medication 2 Medication end
];
